import { createContext } from 'react';

export const EstimateMeasurementsContext = createContext({});
